import Vue from 'vue'
//@ts-ignore
import Vuetify from 'vuetify/lib/framework'
import fr from 'vuetify/src/locale/fr'
//@ts-ignore
//import { preset } from 'vue-cli-plugin-vuetify-preset-crane/preset'

Vue.use(Vuetify);

export const dartyThemes = {
  light: {
    primary: '#d91627',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',      
  }
}

export const dartyProThemes = {
  light: {
    primary: '#AB4FD1',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',      
  }
}

export const mgdThemes = {
  light: {
    primary: '#0197D4',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',   
  }
}

export const defaultTheme = {
  light: {
    primary: '#d91627',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107', 
  }
}


export default new Vuetify({
  //preset,
  theme: {    
    themes: defaultTheme,
  },
    lang: {
      locales: { fr },
      current: 'fr',
    },
});
